/**
 * Import the label-specific translation bundle using webpack's compile-time label constant.
 *
 * @param ln Active language code.
 * @returns Translation module promise.
 */
export default function importCustomLanguage(ln: string): Promise<unknown> {
	return import(
		/* webpackChunkName: "translations" */
		`../i18n/${ln}/${LABEL}/custom.json`
	);
}
